// import { ToastrMessages } from '../../app/ui/usermessages/ToastrMessages';
export class GlobalErrorHandler {
  private _constructorParams;
  private _mError;
  constructor(aConstructorParams: any) {
    this._constructorParams = aConstructorParams;
    this._mError = new Error();
  }

  static handle_logErrorToConsole(message: string, errorData?: [any]): void {
    console.error(message, errorData);
  }

  static handle_networkOffline(fName, errorData): void {
    GlobalErrorHandler.handle_logErrorToConsole(`Error in ${fName}: see stack details. Error: `, errorData);

    var options = {
      closeButton: false,
      positionClass: 'toast-bottom-full-width',
    };
    var aToastr = new ToastrMessages(CrowdHub_App.LANG.BECAME_OFFLINE, '', 'warning', options);
    aToastr.showToastr();
  }
}
